import { useDispatch, useSelector } from 'react-redux';
import { getGenericError } from 'lib/selectors/genericErrors';
import { usePrevious, resolveGenericErrorMessage } from 'lib/utils';
import useTranslate from 'lib/languages/useTranslate';
import { useCallback, useEffect } from 'react';
import { dispatchShowModal, dispatchHideModal } from 'utils/modals';
import { GENERIC_5XX_ERROR_MODAL } from 'constants/shared/modalTypes';
import { useNavigate } from 'react-router-dom';
import { clearGenericError } from 'lib/actions';

const useGenericErrorModal = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const translate = useTranslate('generic');
    const genericError = useSelector(getGenericError) as string | null;
    const prevGenericError = usePrevious(genericError);

    const handleGoBack = useCallback(() => {
        dispatch(clearGenericError());
        dispatchHideModal(dispatch);
        navigate(-1);
    }, [dispatch, navigate]);

    const handleHideModal = useCallback(() => {
        dispatch(clearGenericError());
    }, [dispatch]);

    useEffect(() => {
        if (genericError && !prevGenericError) {
            dispatchShowModal(dispatch, GENERIC_5XX_ERROR_MODAL, {
                message: resolveGenericErrorMessage(genericError, translate),
                goBack: handleGoBack,
                hideModal: handleHideModal,
            });
        }
    }, [genericError, prevGenericError, dispatch, handleGoBack, handleHideModal, translate]);

    useEffect(() => {
        if (!genericError && prevGenericError) {
            dispatchHideModal(dispatch);
        }
    }, [genericError, prevGenericError, dispatch]);
};

export default useGenericErrorModal;
